import * as React from 'react';
import * as PropTypes from 'prop-types';

const HAS_VAT_CONDITIONS = [
  'brand-new',
  'b-stock',
];

class TaxExemptCheckbox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      taxDoesNotApply: this.props.taxDoesNotApply,
    };
    this.toggletaxDoesNotApply = this.toggletaxDoesNotApply.bind(this);
    this.setTaxDoesNotApplyFromCondition = this.setTaxDoesNotApplyFromCondition.bind(this);
    this.taxExemptLabel = this.taxExemptLabel.bind(this);
  }

  componentDidMount() {
    if (this.props.selectField) {
      $(this.props.selectField).change(this.setTaxDoesNotApplyFromCondition);
    }
  }

  setTaxDoesNotApplyFromCondition(event) {
    const condition = event.target.value;
    const taxDoesNotApply = !HAS_VAT_CONDITIONS.includes(condition);
    this.setState({ taxDoesNotApply });
  }

  toggletaxDoesNotApply() {
    this.setState({ taxDoesNotApply: !this.state.taxDoesNotApply });
  }

  taxExemptLabel() {
    if (this.props.isVat) {
      return I18n.t('js.listingForm.taxExempt.vatLabel');
    }
    return I18n.t('js.listingForm.taxExempt.label');
  }

  render() {
    return (
      <div className="form-group">
        <div className="form-group__header">
          <label>{I18n.t('js.listingForm.taxExempt.title')}</label>
        </div>
        <div className="form-group__fields">
          <div className="label-with-checkbox">
            <input name="product[tax_exempt]" type="hidden" value="0" />
            <input
              id="product_tax_exempt"
              type="checkbox"
              name="product[tax_exempt]"
              checked={this.state.taxDoesNotApply}
              onChange={this.toggletaxDoesNotApply}
            />
            <label id="product_tax_exempt" htmlFor="product_tax_exempt">
              {this.taxExemptLabel()}
            </label>
          </div>
        </div>
      </div>
    );
  }
}

TaxExemptCheckbox.propTypes = {
  selectField: PropTypes.string,
  taxDoesNotApply: PropTypes.bool.isRequired,
  isVat: PropTypes.bool,
};

TaxExemptCheckbox.defaultProps = {
  selectField: '',
  isVat: false,
};

export default TaxExemptCheckbox;



// WEBPACK FOOTER //
// ./javascripts/components/listing_form/tax_exempt_checkbox.jsx